<template>
  <svg
    class="bar-vect"
    xmlns="http://www.w3.org/2000/svg"
    :width="w + 'px'"
    :height="h + 'px'"
    :viewBox="'0 0 ' + w + ' ' + h"
  >
    <defs>
      <linearGradient :id="uuid + '-a'" x1="78.071%" x2="50%" y1="-31.592%" y2="90.8%">
        <stop offset="0%" :stop-color="mainColor"/>
        <stop offset="100%" :stop-color="accent"/>
      </linearGradient>
      <linearGradient :id="uuid + '-b'" x1="50%" x2="50%" y1="134.35%" y2="50%">
        <stop offset="0%" :stop-color="mainColor"/>
        <stop offset="100%" :stop-color="accent"/>
      </linearGradient>
      <linearGradient :id="uuid + '-c'" x1="140.434%" x2="-18.835%" y1="29.622%" y2="73.679%">
        <stop offset="0%" :stop-color="mainColor"/>
        <stop offset="100%" :stop-color="accent"/>
      </linearGradient>
    </defs>
    <polygon
      :fill="'url(#' + uuid + '-a)'"
      :points="leftW + ' ' + h + ' ' + leftW + ' ' + lowTop + ' ' + w + ' ' + lowTop + ' ' + w + ' ' + h"
      ref="front"
    />
    <polygon
      :fill="'url(#' + uuid + '-b)'"
      :points="'0 ' + lowMax + ' 0 ' + top + ' ' + leftW + ' ' + lowTop + ' ' + leftW + ' ' + h"
      ref="left"
    />
    <polygon
      :fill="'url(#' + uuid + '-c)'"
      :points="leftW + ' ' + lowTop + ' 0 ' + top + ' ' + (w * 0.8) + ' ' + top + ' ' + w + ' ' + lowTop"
      ref="top"
    />
  </svg>
</template>

<script>
  import StateMixin from '@/components/report/mixins/StateMixin'

  export default {
    name: 'BarVect',
    mixins: [ StateMixin ],
    props: {
      num: { type: Number, required: true },
      target: { type: Number, required: true },
      h: { type: Number, default () { return 250 } },
      w: { type: Number, default () { return 125 } }
    },
    computed: {
      numCalc () { return (this.num / 100) * this.h },

      lowMax () { return this.h - 25 },

      top () { return Math.max( 0, this.lowMax - this.numCalc ) },

      lowTop () { return Math.min( this.h, (this.h - Math.min( 11, this.num )) - this.numCalc ) },

      leftW () { return this.w / 5 }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/svg/BarVect.vue